/* stylelint-disable selector-max-compound-selectors, max-nesting-depth */

:host {
    @include typo-ws-paragraph;

    display: block;

    p {
        margin: 4px 0 0 24px;
    }

    .document-info {
        color: $color-grey-03;

        span:not(:last-of-type) {
            &::after {
                content: ' | ';
            }
        }
    }

    .document-info + p {
        margin-top: 0;
    }
}

@include mq-1 {
    :host {
        @include typo-ws-paragraph-s;
    }
}
